TS.ns('WL');

WL.bulkSimulationListModel = new Class({
    Extends: TS.domain.EditDomain,

    createProperties: function (config) {
        var me = this;

        me.parent(config);

        var bulkSimulationList = me.getDomainProperty('BulkSimulationList');
        if (bulkSimulationList) {
            bulkSimulationList.on('cellValueChanged', me.onPropertyChanged, me);

        }

    },
    onPropertyChanged: function (e) {
        var me = this,
            rec = e.item;

        me.performServerCommand({
            cmd: 'SaveUserProperty',
            submitModel: true,
            extraData: {
                NewValue: e.newValue,
                rowIdx: e.rowIdx,
                ColumnName: e.fieldName
            },
            blockUI: true
        })
    }
});